var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { spinnerStaticStyle, wrapperStyle } from './styles';
function Spinner(_a) {
    var { 'aria-label': ariaLabel, inverted = false } = _a, restProps = __rest(_a, ['aria-label', "inverted"]);
    const { height, width } = restProps;
    // Using an svg element, to be consistent with the type of the Loader component, even though it's not necessary for the spinner.
    return (_jsx("div", Object.assign({ "aria-label": ariaLabel, css: wrapperStyle({
            height: height !== null && height !== void 0 ? height : width,
            inverted,
            width: width !== null && width !== void 0 ? width : height,
        }), "data-testid": "loader-wrapper", role: "alert" }, { children: _jsx("svg", Object.assign({ css: spinnerStaticStyle, viewBox: "0 0 100 100" }, restProps)) })));
}
export default Spinner;
